import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "rankPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"])
  },
  data() {
    return {
      poolInfo: {},
      rankList: [],
      userRankInfo: {}
    };
  },
  methods: {
    async init() {
      let rs = await this.$http.post("/game/rank", {
        game_type: "sheep"
      });
      if (rs.code == 0) {
        this.poolInfo = rs.data.poolInfo;
        this.rankList = rs.data.ranklist;
        this.userRankInfo = rs.data.userRankInfo;
      }
    }
  },
  async mounted() {
    await this.init();
  }
};